import { createSlice } from "@reduxjs/toolkit";
import { Alerta, EmpresaTabByName } from "../constants";

const initialState = {
  comparativoEmpresas: [],
  sucessos: 0,
  avisos: 0,
  erros: 0,
  total: 0,
  proximoAviso: null,
  proximoErro: null,
  totalTarefasErro: 0,
  totalTarefasAviso: 0,
};

export const comparativoEmpresasSelector = (state) => state.complianceDashboard.comparativoEmpresas;
export const sucessosSelector = (state) => state.complianceDashboard.sucessos;
export const avisosSelector = (state) => state.complianceDashboard.avisos;
export const errosSelector = (state) => state.complianceDashboard.erros;
export const totalSelector = (state) => state.complianceDashboard.total;
export const proximoAvisoSelector = (state) => state.complianceDashboard.proximoAviso;
export const proximoErroSelector = (state) => state.complianceDashboard.proximoErro;
export const totalTarefasErroSelector = (state) => state.complianceDashboard.totalTarefasErro;
export const totalTarefasAvisoSelector = (state) => state.complianceDashboard.totalTarefasAviso;

export const slice = createSlice({
  name: "complianceDashboard",
  initialState,
  reducers: {
    fetchDashboard(state, action) {
      state.comparativoEmpresas = [];
      state.sucessos = 0;
      state.avisos = 0;
      state.erros = 0;
      state.proximoAviso = null;
      state.proximoErro = null;
      state.totalTarefasErro = 0;
      state.totalTarefasAviso = 0;
      action.payload.empresas.forEach((empresa) => {
        let sucessos = 0;
        let avisos = 0;
        let erros = 0;
        let tarefasErro = 0;
        let tarefasAviso = 0;
        action.payload.alertasByEmpresaId[empresa.id]
          ?.filter((aba) => EmpresaTabByName[aba.nome]?.modulos?.includes("compliance") === true)
          ?.forEach((aba) => {
            sucessos += aba.totalByNivel[Alerta.Nivel.OK.id];
            avisos += aba.totalByNivel[Alerta.Nivel.Aviso.id];
            erros += aba.totalByNivel[Alerta.Nivel.Erro.id];
            tarefasErro += aba.totalTarefasErro || 0;
            tarefasAviso += aba.totalTarefasAviso || 0;
            aba.alertas.forEach((alerta) => {
              switch (alerta.nivel) {
                case Alerta.Nivel.Aviso.id:
                  if (!state.proximoAviso || alerta.dataVencimento.localeCompare(state.proximoAviso.dataVencimento) < 0) {
                    state.proximoAviso = {
                      ...empresa,
                      aba: aba.nome,
                      dataVencimento: alerta.dataVencimento,
                    };
                  }
                  break;
                case Alerta.Nivel.Erro.id:
                  if (!state.proximoErro || alerta.dataVencimento.localeCompare(state.proximoErro.dataVencimento) < 0) {
                    state.proximoErro = {
                      ...empresa,
                      aba: aba.nome,
                      dataVencimento: alerta.dataVencimento,
                    };
                  }
                  break;
              }
            });
          });
        state.comparativoEmpresas.push({ ...empresa, sucessos, avisos, erros });
        state.sucessos += sucessos;
        state.avisos += avisos;
        state.erros += erros;
        state.totalTarefasErro += tarefasErro;
        state.totalTarefasAviso += tarefasAviso;
      });
      state.total = state.sucessos + state.avisos + state.erros;
    },
  },
  extraReducers: {},
});

export default slice.reducer;

export const { fetchDashboard } = slice.actions;
